import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { useSelector } from 'react-redux';
import { format, FormatTypes } from '../../../../Lib/Format';
import deepEquals from '../../../../Lib/Object/deepEquals';
import { Field, TextOutput } from '../../../Core';
import { ListFieldSection } from '../../../Layout';
import WorksheetDebugPageSection from '../WorksheetDebugPageSection';
import WorksheetStatus from '../WorksheetStatus';
import './WorksheetHeader.scss';
import { WorksheetTestResultsDestinations } from './WorksheetTestResultsDestinations';

let WorksheetHeader = ({ createWorksheetSelector = undefined }) => {
  // TODO These seem to be selecting too much. Fix in QP-4443.
  const header = useSelector(createWorksheetSelector('header', false), deepEquals);
  const type = useSelector(createWorksheetSelector('type', false), deepEquals);

  const isDevMode = process.env.REACT_APP_ENABLE_DEV_MODE === 'true';

  let sampled =
    header.Sample && header.Sample.DateTimeSampled && format({ type: FormatTypes.Date })(header.Sample.DateTimeSampled);
  if (header.Sample && header.Sample.SampledBy) sampled += ` by ${header.Sample.SampledBy.Name}`;

  return (
    <>
      {!window.qest.isFrame && (
        <header className="WorksheetHeader">
          <section className="WorksheetHeader-Headings">
            <span className="WorksheetHeader-Heading WorksheetHeader-Heading-smallHide">{type.Name}</span>
            <div className="WorksheetHeader-Heading WorksheetHeader-Heading-largeHide">
              <div className="WorksheetHeader-StatusIcon">
                <WorksheetStatus status={header} />
              </div>
              <span>{type?.MethodCaption ?? type?.Caption}</span>
            </div>
          </section>

          <div className="WorksheetHeader-Fields">
            <ListFieldSection>
              <Field
                input={<TextOutput />}
                label="Project"
                value={header.Project && `${header.Project.Code} - ${header.Project.Name}`}
              />
              <Field
                input={<TextOutput />}
                label="Source &amp; Material"
                value={
                  header.Sample && header.Sample.MaterialSource && header.Sample.Material
                    ? `${header.Sample.MaterialSource.Name} - ${header.Sample.Material.Name}`
                    : header.Sample && header.Sample.MaterialSource
                    ? header.Sample.MaterialSource.Name
                    : header.Sample && header.Sample.Material
                    ? header.Sample.Material.Name
                    : null
                }
              />
              <Field input={<TextOutput />} label="Sampled" value={sampled} />
              <Field
                input={<TextOutput />}
                label="Specification"
                value={header.Sample && header.Sample.Specification && header.Sample.Specification.Name}
              />
            </ListFieldSection>
          </div>

          <section className="WorksheetHeader-Imports">
            <WorksheetTestResultsDestinations />
          </section>
        </header>
      )}
      {isDevMode && <WorksheetDebugPageSection />}
    </>
  );
};

WorksheetHeader = withInjectedProps(WorksheetHeader);

export { WorksheetHeader };
export default WorksheetHeader;
